/**
 * Module dependencies.
 */

import { CaretDownOutlined, CaretUpOutlined, SwapOutlined } from '@ant-design/icons';
import React, { ReactNode } from 'react';
import styles from './table.module.less';
import classNames from 'classnames';
import { QueryOrderItem } from './row';

/**
 * `Props` type.
 */

type Props<T> = {
  columns: Column<T>[];
  order?: QueryOrderItem[];
  onSortChange?: (key: string) => void;
};

/**
 * Export `Column` type.
 */

export type Column<T> = {
  title: string;
  size?: string;
  dataIndex?: string;
  key: string;
  sortable?: boolean;
  defaultSortDirection?: 'asc' | 'desc';
  render?: (item: T) => ReactNode;
};

/**
 * Export `Header` component.
 */

export function Header<T>({ columns, order, onSortChange }: Props<T>): JSX.Element {
  return (
    <div className={styles.headerWrapper}>
      {columns.map((item: any, index: number) => {
        const { title, key, style, sortable } = item;
        const currentOrder = order?.find(o => o.key === key);

        return (
          <div
            className={classNames(styles.headerColumn, {
              [styles.first]: index === 0,
              [styles.last]: index === columns.length - 1,
              [styles.sortableColumn]: sortable,
              [styles.sortedColumn]: !!currentOrder
            })}
            key={key}
            onClick={sortable && onSortChange ? () => onSortChange(key) : undefined}
            style={typeof style === 'function' ? style() : style}
          >
            {title}

            {sortable && (
              <span className={styles.sortIcon}>
                {!currentOrder && <SwapOutlined rotate={90} />}
                {currentOrder?.direction === 'asc' && <CaretUpOutlined />}
                {currentOrder?.direction === 'desc' && <CaretDownOutlined />}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}
